import React, { useState } from 'react'
import SettingsPage from '../../components/SettingsPage'
import { Divider, makeStyles } from '@material-ui/core'
import { Form } from 'formik'
import { NewFormSection as FormSection } from '../../components/FormSection'
import Grid from '../../components/Grid'
import WeeklyHours from './WeeklyHours'
import DateOverrides from './DateOverrides'
import { useBreakpoint } from '../../hooks'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1)
  },
  divider: {
    margin: theme.spacing(1, 0, 3, 0),
    [theme.breakpoints.down('lg')]: {
      display: 'none'
    }
  }
}))

export default function UserAvailabilityForm() {
  const classes = useStyles()
  const [tab, setTab] = useState('weekly')
  const mobile = useBreakpoint((breakpoints) => breakpoints.down('md'))
  const tabs = [
    { value: 'weekly', label: 'Default Schedule' },
    { value: 'dateOverrides', label: 'Date Overrides' }
  ]

  return (
    <SettingsPage title="Availability">
      <Form>
        <FormSection tabs={mobile ? tabs : null} tabValue={mobile ? tab : null} onTabChange={mobile ? setTab : null}>
          <Grid container spacing={0} justifyContent="space-between" className={classes.root}>
            {(!mobile || tab === 'weekly') && (
              <Grid item xs={12} md={9} xl={6}>
                <WeeklyHours />
              </Grid>
            )}

            <Divider orientation="vertical" flexItem className={classes.divider} />
            {(!mobile || tab === 'dateOverrides') && (
              <Grid item xs={12} md={9} xl={5}>
                <DateOverrides />
              </Grid>
            )}
          </Grid>
        </FormSection>
      </Form>
    </SettingsPage>
  )
}
